<template>
  <div class="w3-container">
    <header>
      <h2>Support</h2>
    </header>

    <div class="w3-center">
      <h4>Contact Us</h4>
      <p>We'd love to hear from you!</p>
    </div>
    <contact></contact>
  </div>
</template>

<script>
import contact from '@/components/Contact'
var dataStore = require('../dataStore').default

export default {
  name: 'Support',
  data() {
    return {
      state: dataStore.state
    }
  },
  components: {
    contact
  }
}
</script>

<style scoped>
</style>



// WEBPACK FOOTER //
// src/components/Support.vue